import { FC, ReactNode } from 'react'

import { styled } from 'styled-components'

import { outline, onSurfaceVariant } from 'core/styles'

type DialogDetailRowProps = {
  label: string
  value?: ReactNode
  labelOnly?: boolean
}

const DialogDetailRow: FC<DialogDetailRowProps> = ({ label, value, labelOnly }) => (
  <Row>
    <Label>{label}</Label>
    {!labelOnly && <Value>{value}</Value>}
  </Row>
)

export default DialogDetailRow

const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  margin: 8px 0;
  border-bottom: 1px solid ${outline};
  padding: 8px 0;

  &:last-child {
    border-bottom: none;
  }
`

const Label = styled.div`
  margin-bottom: 4px;
  width: 136px;
  color: ${onSurfaceVariant};
  font-weight: 500;
`

const Value = styled.div`
  margin-bottom: 8px;
  color: ${onSurfaceVariant};
`
